import gsap from 'gsap/dist/gsap'
import { useLayoutEffect, useRef } from 'react'

import { selectVideoTopicColor } from '~/bootcamp/slices/vcc-data.slice'
import { useAppSelector } from '~/redux/hooks'
import { Breakpoint, useCheckBreakpoint } from '~/utils'

const AnimationBubble = ({
  onAnimationComplete = () => null,
  shouldAnimate = true,
}: {
  onAnimationComplete?: () => void
  shouldAnimate?: boolean
}): React.ReactElement => {
  const { bgClass } = useAppSelector(selectVideoTopicColor)
  const bubbleRef = useRef(null)
  const isDesktop = useCheckBreakpoint({ gt: Breakpoint.LG })

  useLayoutEffect(() => {
    if (!shouldAnimate) {
      gsap.set(bubbleRef.current, {
        scale: 1,
      })
    } else {
      gsap.to(bubbleRef.current, {
        duration: 0.4,
        scale: 1,
        onComplete: onAnimationComplete,
      })
    }
  }, [onAnimationComplete, shouldAnimate])

  const sizeClass = isDesktop ? 'w-32 h-32' : 'w-24 h-24'

  return (
    <span
      className={`rounded-full scale-50  inline-block absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-0 ${
        bgClass || 'bg-purple'
      } ${sizeClass} ${isDesktop ? '-ml-1 mt-2.5' : 'mt-1.5 '}`}
      ref={bubbleRef}
    />
  )
}

export default AnimationBubble
